import React from "react";
import {
  Table,
  TableBody,
  TableFooter,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { RaisedButton } from "material-ui";

export default ({
  id,
  name,
  price,
  features,
  buttonLabel,
  onTouchTap,
  buttonDisabled
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: 350,
        paddingTop: 10,
        paddingBottom: 10,
        border: "1px solid #EAEAEA",
        margin: 10
      }}
    >
      <Table
        fixedHeader={true}
        fixedFooter={true}
        selectable={false}
        multiSelectable={false}
      >
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
          enableSelectAll={false}
        >
          <TableRow>
            <TableHeaderColumn colSpan="5" style={{ textAlign: "center" }}>
              {name}
              <div style={{ fontSize: 28 }}>${price}</div>
            </TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={false}
          deselectOnClickaway={true}
          showRowHover={true}
          stripedRows={true}
        >
          {features.map((row, index) => (
            <TableRow key={index} selected={false}>
              <TableRowColumn>{row}</TableRowColumn>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <RaisedButton
        style={{ marginTop: 20, alignSelf: "center" }}
        label={buttonLabel}
        disabled={buttonDisabled}
        onTouchTap={onTouchTap}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PaymentPlanCard.js